import React from "react";

import { ChatConversation, ChatSetup } from "../../..";

interface Dataset {
  players: string[];
  movementTypeId: string;
  files: File[];
  sessions: string[];
  startDate?: Date;
  endDate?: Date;
}

interface Message {
  id: string;
  role: "user" | "assistant";
  content: string;
  timestamp: Date;
  streamError?: { message: string; suggestion: string };
}

interface FreeFormModeProps {
  isChatActive: boolean;
  dataset: Dataset;
  setDataset: React.Dispatch<React.SetStateAction<Dataset>>;
  inputValue: string;
  setInputValue: (value: string) => void;
  onVoiceTranscript: (transcript: string) => void;
  onInitiateChatWithData: (
    sessionId: string,
    containerId: string,
    userMessageText: string,
    fileIds?: string[],
    dataSummary?: string,
  ) => void;
  messages: Message[];
  onSendMessage: () => void;
  isStreaming: boolean;
  onSelectedReportChange: (html: string | null) => void;
  onOpenImportModal?: () => void;
}

export const FreeFormMode: React.FC<FreeFormModeProps> = ({
  isChatActive,
  dataset,
  setDataset,
  inputValue,
  setInputValue,
  onVoiceTranscript,
  onInitiateChatWithData,
  messages,
  onSendMessage,
  isStreaming,
  onSelectedReportChange,
  onOpenImportModal,
}) => {
  if (!isChatActive) {
    return (
      <ChatSetup
        dataset={dataset}
        setDataset={setDataset}
        inputValue={inputValue}
        setInputValue={setInputValue}
        onVoiceTranscript={onVoiceTranscript}
        onInitiateChatWithData={onInitiateChatWithData}
        onOpenImportModal={onOpenImportModal}
      />
    );
  }

  return (
    <ChatConversation
      messages={messages}
      inputValue={inputValue}
      setInputValue={setInputValue}
      onSendMessage={onSendMessage}
      onVoiceTranscript={onVoiceTranscript}
      dataset={dataset}
      isLoading={isStreaming}
      onSelectedReportChange={onSelectedReportChange}
    />
  );
};
